import Blue from "~/core";

new Blue({
	name: 'Footer',
	selector: ".footer",
	setup(footer) {
		/* Script for the footer goes here */
	}
});